<template>
  <div :class="['lr-modal', {'hide': !show}]">
    <div class="lr-box">
      <i class="fas fa-spinner fa-spin fa-2x"></i>
      <div v-if="!!message" class="lr-loader-msg">{{message}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loader',
  computed: {
    loader () { return this.$store.state.global.loader },
    show: {
      get () { return this.loader.show },
      set (x) {
        this.$store.commit('global/setLoaderData', {
          show: x,
          message: ''
        })
      }
    },
    message () { return this.loader.message }
  },
  methods: {
  },
  mounted () {
  },
}
</script>

<style lang="scss" scoped>
.lr-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  display: flex;
  justify-content: center!important;
  align-items: center!important;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.lr-box {
  background: #fff;
  padding: 20px;
  border-radius: 6px;
  box-shadow: 3px 3px 2px rgba(0,0,0, .3);
  text-align: center;
}

.fa-spinner{
  color: #6185aa;
}
.lr-loader-msg{
  margin-top: 10px;
  font-weight: 600;
  color: #45505b;
  letter-spacing: .5px;
}
</style>



// WEBPACK FOOTER //
// src/components/App/Loader.vue